module.exports = __webpack_public_path__ + "img/goal-twelve-en.01343bf0.png";